import React from "react";

import { Icon } from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import OtherProducts from "../OtherProducts/OtherProducts";
import { useInView } from "react-intersection-observer";

import threeProducts from "../../../assets/images/Infinite313x110/three-products.png";
import threeProductsHorizontal from "../../../assets/images/Infinite313x110/three-products-horizontal.png";
import office from "../../../assets/images/office.png";
import wifi6 from "../../../assets/images/wifi-6.png";
import product313x110 from "../../../assets/images/Infinite313x110/313x110.png";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import allProducts from "../../../assets/images/all-products.jpeg";
import productWallpaper from "../../../assets/images/Infinite313x110/313x110-wallpaper-wall.png";
import productWavesBlack from "../../../assets/images/Infinite313x110/product-waves-black.png";
import product313ShadowOne from "../../../assets/images/Infinite313x110/313x110-black-shadow-one.png";
import product313ShadowTwo from "../../../assets/images/Infinite313x110/313x110-black-shadow-two.png";
import product313ShadowThree from "../../../assets/images/Infinite313x110/313x110-black-shadow-three.png";

import cs from "classnames";

import "./Infinite313.scss";

const Infinite313 = () => {
  const navigate = useNavigate();
  const [productTitleRef, productTitleVisibility] = useInView();
  const [productImageRef, productImageVisibility] = useInView();
  const [topSliderTitleRef, topSliderTitleVisibility] = useInView();
  const [topSliderRef, topSliderVisibility] = useInView();
  const [wifiSixTitleRef, wifiSixTitleVisibility] = useInView();
  const [wifiSixSubTitleRef, wifiSixSubTitleVisibility] = useInView();
  const [wifiSixImageRef, wifiSixImageVisibility] = useInView();
  const [officeHeadRef, officeHeadVisibility] = useInView();
  const [officeImageRef, officeImageVisibility] = useInView();
  const [threeProductsTitleRef, threeProductsTitleVisibility] = useInView();
  const [productOneRef, productOneVisibility] = useInView();
  const [productTwoRef, productTwoVisibility] = useInView();
  const [productThreeRef, productThreeVisibility] = useInView();
  const [otherProductsTitleRef, otherProductsTitleVisibility] = useInView();

  return (
    <div className="InfiniteProduct313">
      <div className="ProductHeader313">
        <div className="ProductHeader313__container">
          <div className="ProductHeader313__left">
            <div
              className="ProductHeader313__products"
              onClick={() => {
                navigate("/products");
              }}
            >
              Products
            </div>
            <Icon className="ProductHeader313__icon" icon="chevron-right" />
            <div className="ProductHeader313__product">Infinite 313</div>
          </div>
          <div className="ProductHeader313__right">
            <div className="ProductHeader313__design">Design</div>
            <div className="ProductHeader313__features">Features</div>
            <div className="ProductHeader313__specifications">
              Specifications
            </div>
          </div>
        </div>
      </div>
      <div className="ProductImage313">
        <div className="ProductImage313__container">
          <div
            ref={productTitleRef}
            className={cs(
              "ProductImage313__title",
              productTitleVisibility && "ProductImage313__title-animation",
            )}
          >
            Infinite <span>313</span>{" "}
          </div>
          <img
            ref={productImageRef}
            className={cs(
              "ProductImage313__image",
              productImageVisibility && "ProductImage313__image-animation",
            )}
            src={threeProducts}
          />
        </div>
      </div>

      <div className="TopSliderTitle313">
        <div
          ref={topSliderTitleRef}
          className={cs(
            "TopSliderTitle313__title",
            topSliderTitleVisibility && "TopSliderTitle313__title-animation",
          )}
        >
          Superior <span>Wi-Fi</span> Reach for Large Spaces
        </div>
      </div>

      <div
        ref={topSliderRef}
        className={cs(
          "TopSlider313",
          topSliderVisibility && "TopSlider313-animation",
        )}
      >
        <div className="TopSlider313__carts">
          <FlickitySlider
            options={{
              lazyLoad: 10,
              wrapAround: true,
              contain: true,
              draggable: true,
              autoPlay: true,
              freeScroll: true,
              imagesLoaded: true,
              // prevNextButtons: false,
            }}
          >
            <div className={cs("TopSlider313__cart", "TopSlider313__cartOne")}>
              <div className="TopSlider313__cartOne-textOne">
                Robust and versatile
              </div>
              <img
                loading="lazy"
                src={threeProductsHorizontal}
                className="TopSlider313__cartOne-image"
              />
              <div className="TopSlider313__cartOne-textTwo">
                With multiple spatial streams and dual-band capability, you can
                also broadcast, play games, and work on numerous devices at
                once.
              </div>
            </div>
            <div className={cs("TopSlider313__cart", "TopSlider313__cartTwo")}>
              <div className="TopSlider313__cartTwo-textOne">
                High-Powered Processor
              </div>
              <img loading="lazy" className="TopSlider313__cartTwo-image" />
              <div className="TopSlider313__cartTwo-textTwo">
                Qualcomm Atheros A53 Processor IPQ8072A, a powerful
                System-on-Chip (SoC) optimised specifically for networking
                applications.
              </div>
            </div>
            <div
              className={cs("TopSlider313__cart", "TopSlider313__cartThree")}
            >
              <div className="TopSlider313__cartThree-textOne">
                Impressive Data Rates
              </div>
              <div className="TopSlider313__cartThree-textTwo">
                Expect nothing but stellar data rates with Infinite 313.
              </div>
            </div>
            <div className={cs("TopSlider313__cart", "TopSlider313__cartFour")}>
              <div className="TopSlider313__cartFour-textOne">
                Powerful Signal Strength
              </div>
              <img
                loading="lazy"
                src={office}
                className="TopSlider313__cartFour-image"
              />
              <div className="TopSlider313__cartFour-textTwo">
                Signal strength is important, especially in large, crowded
                spaces like shopping centres.
              </div>
            </div>
            <div className={cs("TopSlider313__cart", "TopSlider313__cartFive")}>
              <div className="TopSlider313__cartFive-textOne">
                High-Speed Dual-Band Performance
              </div>
              <img
                loading="lazy"
                src={productWavesBlack}
                className="TopSlider313__cartFive-image"
              />
              <div className="TopSlider313__cartFive-textTwo">
                Delivers lightning-fast speeds of 2.4 Gbps on the 5GHz band and
                dependable connectivity at 1.2 Gbps on the 2.4GHz band,
                accommodating multiple users and various devices with ease.
              </div>
            </div>
            <div className={cs("TopSlider313__cart", "TopSlider313__cartSix")}>
              <div className="TopSlider313__cartSix-textOne">
                Control via application{" "}
              </div>
              <img loading="lazy" className="TopSlider313__cartSix-image" />
              <div className="TopSlider313__cartSix-textTwo">
                Software provides easy device management via a user-friendly
                interface, enabling remote adjustments, real-time monitoring,
                and notifications for enhanced accessibility.
              </div>
            </div>
          </FlickitySlider>
        </div>
      </div>

      <div className="WifiSix313">
        <div className="WifiSix313__container">
          <img
            ref={wifiSixTitleRef}
            loading="lazy"
            className={cs(
              "WifiSix313__title",
              wifiSixTitleVisibility && "WifiSix313__title-animation",
            )}
            src={wifi6}
          />
          <div
            ref={wifiSixSubTitleRef}
            className={cs(
              "WifiSix313__subtitle",
              wifiSixSubTitleVisibility && "WifiSix313__subtitle-animation",
            )}
          >
            Designed to provide exceptional connectivity in even the most
            demanding environments.
          </div>
          <div className="WifiSix313__body">
            <img
              ref={wifiSixImageRef}
              loading="lazy"
              className={cs(
                "WifiSix313__image",
                wifiSixImageVisibility && "WifiSix313__image-animation",
              )}
              src={product313x110}
            />
            {/*<div className="WifiSix313__image-description">*/}
            {/*  Experience a blazing-fast performance with ultra-high speed.*/}
            {/*</div>*/}
          </div>
        </div>
      </div>

      <div className="Office313">
        <div className="Office313__container">
          <div
            ref={officeHeadRef}
            className={cs(
              "Office313__head",
              officeHeadVisibility && "Office313__head-animation",
            )}
          >
            <div className="Office313__head-left">
              The ultimate access point <br /> for your business
            </div>
            <div className="Office313__head-right">
              <div className="Office313__head-right-left">+50</div>
              <div className="Office313__head-right-right">
                Perfect for big areas like malls, able to accommodate a
                multitude of smartphones and other devices that customers may
                utilize.
              </div>
            </div>
          </div>
          <img
            ref={officeImageRef}
            loading="lazy"
            className={cs(
              "Office313__image",
              officeImageVisibility && "Office313__image-animation",
            )}
            src={office}
          />
        </div>
      </div>

      <div className="ThreeProductsTitle313">
        <div
          ref={threeProductsTitleRef}
          className={cs(
            "ThreeProductsTitle313__title",
            threeProductsTitleVisibility &&
              "ThreeProductsTitle313__title-animation",
          )}
        >
          Elevating Connectivity with Infinite 313
        </div>
      </div>

      <div className="ThreeProducts313">
        <div className="ThreeProducts313__container">
          <div
            ref={productOneRef}
            className={cs(
              "ThreeProducts313__section",
              productOneVisibility && "ThreeProducts313__section-animation",
            )}
          >
            <div className="ThreeProducts313__text">
              <div className="ThreeProducts313__text-title">
                Design Elegance
              </div>
              <div className="ThreeProducts313__text-description">
                Infinite 313 features a modern and adaptable design, seamlessly
                blending into any environment, whether it's stadiums, malls, or
                office spaces.
              </div>
            </div>
            <img
              className="ThreeProducts313__image"
              src={product313ShadowOne}
            />
          </div>{" "}
          <div
            ref={productTwoRef}
            className={cs(
              "ThreeProducts313__section",
              productTwoVisibility && "ThreeProducts313__section-animation",
            )}
          >
            <img
              className="ThreeProducts313__image"
              src={product313ShadowTwo}
            />

            <div className="ThreeProducts313__text">
              <div className="ThreeProducts313__text-title">
                Ultra-Speed Performance
              </div>
              <div className="ThreeProducts313__text-description">
                With Wi-Fi 6 technology, Infinite 313 delivers blazing-fast
                speeds, ensuring smooth and uninterrupted connectivity for users
                across various devices and applications.
              </div>
            </div>
          </div>{" "}
          <div
            ref={productThreeRef}
            className={cs(
              "ThreeProducts313__section",
              productThreeVisibility && "ThreeProducts313__section-animation",
            )}
          >
            <div className="ThreeProducts313__text">
              <div className="ThreeProducts313__text-title">
                Reliable Support and Control
              </div>
              <div className="ThreeProducts313__text-description">
                Infinite 313 offers robust reliability and support, coupled with
                intuitive software control. Users can remotely manage and
                monitor their network settings with ease, ensuring optimal
                performance and peace of mind.
              </div>
            </div>
            <img
              className="ThreeProducts313__image"
              src={product313ShadowThree}
            />
          </div>
        </div>
      </div>

      <div className="Specifications313">
        <div className="Specifications313__container">
          <div className="Specifications313__title">Specifications</div>
          <div className="Specifications313__subtitle">Hardware</div>
          <div className="Specifications313__section">
            <div className="Specifications313__section-left">
              <div className="Specifications313__section-title">
                Wi-Fi Chipset{" "}
              </div>
            </div>
            <div className="Specifications313__section-right">
              <div className="Specifications313__section-description">
                Qualcomm Processor IPQ8072A
              </div>{" "}
              <div className="Specifications313__section-description">
                2.4GHz Wi-Fi 6 band (4x4) , 1147Mbps
              </div>
              <div className="Specifications313__section-description">
                5GHz Wi-Fi 6 band (4x4) , 2401Mbps
              </div>
              <div
                className={cs(
                  "Specifications313__section-description",
                  "Specifications313__section-description-borderNone",
                )}
              >
                5.2dBi x 7dBi internal 2.4GHz & 5GHz dual antenna
              </div>
            </div>
          </div>

          <div className="Specifications313__section">
            <div className="Specifications313__section-left">
              <div className="Specifications313__section-title">
                Device Interfaces
              </div>
            </div>
            <div className="Specifications313__section-right">
              <div className="Specifications313__section-description">
                1x 1Gbps Ethernet Port (Active PoE)
              </div>
              <div className="Specifications313__section-description">
                1x 2.5Gbps Ethernet Port
              </div>
              <div className="Specifications313__section-description">
                1x Reset Button
              </div>{" "}
              <div className="Specifications313__section-description">
                1x DC Jack
              </div>
              <div
                className={cs(
                  "Specifications313__section-description",
                  "Specifications313__section-description-borderNone",
                )}
              >
                Power consumption 16W
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ImageSlider313">
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="ImageSlider313__image-container">
            <img
              loading="lazy"
              className="ImageSlider313__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider313__image-container">
            <img
              loading="lazy"
              className="ImageSlider313__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
          <div className="ImageSlider313__image-container">
            <img
              loading="lazy"
              className="ImageSlider313__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider313__image-container">
            <img
              loading="lazy"
              className="ImageSlider313__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
        </FlickitySlider>
      </div>

      <div className="OtherProducts313">
        <div className="OtherProducts313__container">
          <div
            ref={otherProductsTitleRef}
            className={cs(
              "OtherProducts313__title",
              otherProductsTitleVisibility &&
                "OtherProducts313__title-animation",
            )}
          >
            Other Products
          </div>
          <OtherProducts />
        </div>
      </div>
    </div>
  );
};

export default Infinite313;
